// Explicit evidence distinguishes cancellation before delivery from a service
// that started and was subsequently cancelled. Never infer this from dates.
const metadataFor = record => {
  const value = record?.metadata ?? record?.metadata_json;
  if (value && typeof value === 'object') return value;
  try { return JSON.parse(value || '{}') || {}; } catch { return {}; }
};
const isInterventionCancelledBeforeStart = record => metadataFor(record)?.cancellation?.beforeStart === true;
const cancellationError = (code, publicMessage, status = 409) => Object.assign(new Error(code), { code, publicMessage, status });
const assertInterventionNotCancelledBeforeStart = record => {
  if (isInterventionCancelledBeforeStart(record)) {
    throw cancellationError('intervention_cancelled_before_start',
      'This intervention was cancelled before it started. It cannot be activated, revised, or used for new payments or approval letters.');
  }
};
module.exports = { metadataFor, isInterventionCancelledBeforeStart, assertInterventionNotCancelledBeforeStart, cancellationError };
